import { useEffect, useRef, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Container,
  Input,
  SelectDropdown,
  Col,
  Row,
  CloseButton,
} from '@uhg-uicl/ui-core/dist';
import { IFacilityItem, IPayerAddressItem, IPayerMasterItem, IRRDInventoryDetails, IRRDInventoryItem } from '../Infrastructure/Interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../Store/StoreInit';
import { fetchPayerMasterList } from '../Store/PayerMasterReducer';
import { fetchPayerAddressList } from '../Store/GetDropDownsValuesReducer';
import { message } from 'antd';
import RRDDocumentUpload from './RRDDocumentUpload';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';

interface Props {
  isOpen?: boolean; // Expect a boolean for the initial state
  setIsOpen?: (isOpen: boolean) => void; // Function to update the state
  rrdInventoryItem: any;
  refreshData: any;
}

function RRDInventoryModal({ isOpen = false, setIsOpen = () => { }, rrdInventoryItem, refreshData }: Props) {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchPayerMasterList());
    dispatch(fetchPayerAddressList());
  }, [dispatch]);
  const [showDropdown, setShowDropdown] = useState(false); // State to toggle dropdown visibility
  const [payerAddressSearchText, setPayerAddressSearchText] = useState(''); // State for search input
  const [payerAddressShowDropdown, setPayerAddressShowDropdown] = useState(false); // State to toggle dropdown visibility
  const payermasterlist: IPayerMasterItem[] = useSelector((state: any) => {
    return state.payerMasterList.payerMasterList;
  });
  var payerAddresslist: IPayerAddressItem[] = useSelector((state: any) => {
    return state.payerAddressList.payerAddressList;
  });
  var facilityAddressList: IFacilityItem[] = useSelector((state: any) => {
    return state.facilityDetailList.facilityDetailsList;
  });

  const [uploadDocumentModalOpen, setUploadDocumentModalOpen] = useState(false);
  const [showGuarantorFields, setShowGuarantorFields] = useState(false);
  const [showHomeLessFields, setShowHomeLessFields] = useState(false);
  const [showBREFields, setShowBREFields] = useState(false);
  const [showPayerNameFields, setShowPayerNameFields] = useState(false);
  const [showPatientFields, setShowPatientFields] = useState(false);
  const [uploading, setuploading] = useState(false);  

  const { accounts } = useMsal();
  const userdetails = localStorage.getItem('userdetails');
  const parsedUserDetails = userdetails ? JSON.parse(userdetails) : null;
  const [gridRecords, setGridRecords] = useState<IRRDInventoryDetails[]>([]); // State to store grid records
  const arrregioncodes: string[] = (process.env.REACT_APP_REGION_CODES as string).split(',');

  const userid = parsedUserDetails && parsedUserDetails[0]?.portal_Id !== ''
    ? parsedUserDetails[0]?.portal_Id
    : accounts[0]?.username;

  const [validationErrors, setValidationErrors] = useState({
    clientName:'',
    region:'',
    accountNumber:'',
    mrn:'',
    sendTo:'',
    requestType:'',
    firstName:'',
    lastNane:'',
    payerName:'',
    address:'',
    city:'',
    state:'',
    zip: '', // Track validation errors for the zip field
  });

  const fetchForms = async () => {
    setGridRecords([]); // Clear previous records before fetching new ones
    if (data.accountNumber.trim() != '') {
      try {
        //const tokenurl = process.env.REACT_APP_RRD_OPTIMIZATION_TOKEN_URL as string;
        const baseurl = process.env.REACT_APP_RRD_OPTIMIZATION_BASE_URL as string;

        //const getToken = await axios.get(tokenurl);

        //if (!getToken.data.success) { return; }

        const formsResponse = await axios.get(`${baseurl}/Inventory/InProgress/Account`, {
          params:{
            accountNo: data.accountNumber.trim()
          },
          headers: {
            accept: 'text/plain'
          },
        });

        if (formsResponse.data.success && formsResponse.data.result != null) {
          let filterdresponse = formsResponse.data.result;
          setGridRecords(filterdresponse || []); // Update the state with the modified records, ensure it's always an array
        } else {
          throw new Error('Failed to fetch forms');
        }
      } catch (error) {
        console.error('Error fetching forms:', error);
      }
    }
  };

  const [data, setdata] = useState({
    inventoryMasterId: 0,
    transactionId:'',
    clientName: '',
    lockboxAddress: '',
    region: '',
    accountNumber: '',
    mrn: '',
    facilityAddressId:0,
    facilityName: '',
    facilityAddress: '',
    facilityCity: '',
    facilityState: '',
    facilityZip: '',
    facilityCode:'',
    facilityPhoneNo:'',
    sendFrom: '',
    sendTo: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    displayName:'',
    firstName:'',
    lastName:'',
    payerName: '',
    payerAddress: '',
    payerCity: '',
    payerState: '',
    PayerZip: '',
    requestType: ''
  });

  useEffect(() => {
      if (rrdInventoryItem) {
        // Populate the state with values from rrdInventoryItem
        setdata((prevdata) => ({
          ...prevdata,
          inventoryMasterId: rrdInventoryItem?.inventoryMasterId || 0,
          transactionId: rrdInventoryItem?.transactionId || 0,
          clientName: rrdInventoryItem?.clientName || '',
          lockboxAddress: rrdInventoryItem?.senderAddress || '',
          region: rrdInventoryItem?.region || '',
          accountNumber: rrdInventoryItem?.accountNumber || '',
          mrn: rrdInventoryItem?.mrn || '',
          facilityName: rrdInventoryItem?.senderName || '',
          facilityAddress: rrdInventoryItem?.senderAddress || '',
          facilityCity: rrdInventoryItem?.senderCity || '',
          facilityState: rrdInventoryItem?.senderState || '',
          facilityZip: rrdInventoryItem?.senderZip || '',
          facilityCode: rrdInventoryItem?.senderCode || '',
          facilityPhoneNo: rrdInventoryItem?.senderPhoneNo || '',
          sendFrom: rrdInventoryItem?.sendFrom || '',
          sendTo: rrdInventoryItem?.sendTo || '',
          address: rrdInventoryItem?.receiverAddress || '',
          city: rrdInventoryItem?.receiverCity || '',
          state: rrdInventoryItem?.receiverState || '',
          zip: rrdInventoryItem?.receiverZip || '',
          displayName: rrdInventoryItem?.displayName || '',
          payerName: rrdInventoryItem?.receiverName || '',
          payerAddress: rrdInventoryItem?.payerAddress || '',
          payerCity: rrdInventoryItem?.payerCity || '',
          payerState: rrdInventoryItem?.payerState || '',
          PayerZip: rrdInventoryItem?.PayerZip || '',
          requestType: rrdInventoryItem?.requestType || '',
        }));
      } else {
        // Reset the state to default values
        setdata({
          inventoryMasterId: 0,
          transactionId:'',
          clientName: '',
          lockboxAddress: '',
          region: '',
          accountNumber: '',
          mrn: '',
          facilityAddressId: 0,
          facilityName: '',
          facilityAddress: '',
          facilityCity: '',
          facilityState: '',
          facilityZip: '',
          facilityCode: '',
          facilityPhoneNo: '',
          sendFrom: '',
          sendTo: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          displayName: '',
          firstName:'',
          lastName:'',
          payerName: '',
          payerAddress: '',
          payerCity: '',
          payerState: '',
          PayerZip: '',
          requestType: '',
        });
      }
      //fetchForms();
      setAddressFields(rrdInventoryItem?.sendTo);
  }, [rrdInventoryItem]);


  useEffect(() =>{
    setValidationErrors(() =>({
      ...validationErrors,
      clientName:'',
    region:'',
    accountNumber:'',
    mrn:'',
    sendTo:'',
    requestType:'',
    firstName:'',
    lastNane:'',
    payerName:'',
    address:'',
    city:'',
    state:'',
    zip: '', 
    }))
  },[isOpen]);

  const handleClose = () => {
    //setModalOpen(false);
    setIsOpen(false); // Notify parent component
  };

  const filteredOptions = (payermasterlist || [])
    .filter((payer) => payer.isActive && payer.payerName.toLowerCase().includes(data.payerName.toLowerCase()))
    .map((payer) => ({
      label: payer.payerName,
      value: payer.payerName,
    }));

    const payerAddressFilteredOptions = (payerAddresslist || [])
    .filter((address) => 
      address.isActive && (
        payerAddressSearchText.trim() !== '' // Search based on input text in address field
          ? (
            address.payerName.toLowerCase().includes(payerAddressSearchText.toLowerCase()) ||
            address.address.toLowerCase().includes(payerAddressSearchText.toLowerCase()) ||
            address.city.toLowerCase().includes(payerAddressSearchText.toLowerCase()) ||
            address.state.toLowerCase().includes(payerAddressSearchText.toLowerCase()) ||
            address.zip.toLowerCase().includes(payerAddressSearchText.toLowerCase())
          )
          : data.payerName.trim() !== '' // Filter based on payer name if no search text is provided
            ? address.payerName.toLowerCase() === data.payerName.toLowerCase()
            : true // Show all addresses if no payer name or search text is provided
      )
    )
    .map((address) => ({
      label: address.payerName + ' - ' + address.address + ' - ' + address.city + ' - ' + address.state + ' - ' + address.zip,
      value: address.payerAddressId.toString(),
    }));

  const handleOptionClick = (option: { label: string; value: string }) => {
    //setSearchText(option.label); // Set the selected value
    setdata((prevdata) => ({ ...prevdata, payerName: option.label }));
    setShowDropdown(false); // Hide the dropdown
    if (option.label != '') {
      setPayerAddressSearchText('');
    }
  };

  const handlePayerAddressOptionClick = (option: { label: string; value: string }) => {
    const selectedAddress = payerAddresslist.find((x) => x.payerAddressId === Number(option.value));
  
    if (selectedAddress) {
      setdata({
        ...data,
        payerName: selectedAddress.payerName || '', // Set payer name corresponding to the selected address
        address: selectedAddress.address || '',
        city: selectedAddress.city || '',
        state: selectedAddress.state || '',
        zip: selectedAddress.zip || '',
      });
    }
  
    setPayerAddressSearchText(option.value); // Set the selected value
    setPayerAddressShowDropdown(false); // Hide the dropdown
  };

  // Create refs for dropdown and input elements
  const payerNameDropdownRef = useRef<HTMLDivElement | null>(null);
  const payerNameDivRef = useRef<HTMLDivElement | null>(null); // Ref for the input container

  const payerAddressDropdownRef = useRef<HTMLDivElement | null>(null);
  const payerAddressDivRef = useRef<HTMLDivElement | null>(null); // Ref for the input container

  useEffect(() => {
    //setIsDataSaved(false);
    const handleClickOutside = (event: MouseEvent) => {
      if (
        payerNameDropdownRef.current &&
        !payerNameDropdownRef.current.contains(event.target as Node) &&
        payerNameDivRef.current &&
        !payerNameDivRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false); // Close the dropdown
      }

      if (
        payerAddressDropdownRef.current &&
        !payerAddressDropdownRef.current.contains(event.target as Node) &&
        payerAddressDivRef.current &&
        !payerAddressDivRef.current.contains(event.target as Node)
      ) {
        setPayerAddressShowDropdown(false); // Close the dropdown
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleRequestTypeChange = (e: any, elementId: string) => {
      setdata((prevdata) => ({
        ...prevdata,
        requestType: e.value,
        sendTo: e.value,
      }));
      setAddressFields(e.value ||  "default"); // Use "default" if newSendTo is empty
  };

  const handleChange = (e: any, elementId: string) => {

    if (elementId === 'requestType') {
      const newSendTo = e.value === 'Payer' ? 'Payer' : '';
      setdata((prevdata) => ({
        ...prevdata,
        sendTo: e.value,
      }));
      setAddressFields(e.value ||  "default"); // Use "default" if newSendTo is empty
    }

    if (elementId == 'lockboxAddress') {
      var facilitydetail = facilityAddressList.find(x => x.facilityAddressId == e.value);
      setdata((prevdata) => ({
        ...prevdata,
        facilityAddressId: facilitydetail?.facilityAddressId || 0,
        facilityAddress: facilitydetail?.lockboxAddress || '',
        facilityCity: facilitydetail?.lockboxCity || '',
        facilityState: facilitydetail?.lockboxState || '',
        facilityZip: facilitydetail?.lockboxZip || '',
        facilityCode: facilitydetail?.facilityCode.toString() || '',
        facilityName: facilitydetail?.facilityName || '',
        facilityPhoneNo: facilitydetail?.lockboxPhone || '',
        sendFrom: facilitydetail?.efrFacilityName || '',
        region: facilitydetail?.region.toUpperCase() || ''
      }))
    }
    if (elementId == 'sendTo') {
      setdata((prevdata) => ({
        ...prevdata,
        sendTo: e.value,
      }));
      setAddressFields(e.value)
    }
    if (elementId != 'lockboxAddress') {
      let inputvalue = e.value;
      if (inputvalue.endsWith(',')) {
        inputvalue = inputvalue.slice(0, -1);
      }
      setdata({
        ...data,
        [elementId]: inputvalue,
      });
    }
  };

  useEffect(() =>{
    fetchForms();
  },[data.accountNumber]);
  
  useEffect(() =>{
    setPayerAddressShowDropdown(false); // Close the dropdown
    var findfacilityid = facilityAddressList.find(x => x.facilityName == rrdInventoryItem?.senderName 
      && x.lockboxAddress == rrdInventoryItem?.senderAddress && x.lockboxZip == rrdInventoryItem?.senderZip)?.facilityAddressId;

    setdata((prevdata) => ({
      ...prevdata,
      facilityAddressId: findfacilityid || 0
    }));
  },[isOpen]);

  function setAddressFields(value: keyof typeof fieldStates) {
    const fieldStates = {
      Guarantor: { showGuarantorFields: true, showHomeLessFields: false, showPayerNameFields: false, showPatientFields: false, showBREFields: false },
      HomeLess: { showGuarantorFields: false, showHomeLessFields: true, showPayerNameFields: false, showPatientFields: false, showBREFields: false },
      Payer: { showGuarantorFields: false, showHomeLessFields: false, showPayerNameFields: true, showPatientFields: false, showBREFields: false },
      Patient: { showGuarantorFields: false, showHomeLessFields: false, showPayerNameFields: false, showPatientFields: true, showBREFields: false },
      'Override Address': { showGuarantorFields: false, showHomeLessFields: false, showPayerNameFields: false, showPatientFields: false, showBREFields: true },
      default: { showGuarantorFields: false, showHomeLessFields: false, showPayerNameFields: false, showPatientFields: false, showBREFields: false },
    };

    const newState = fieldStates[value] || fieldStates.default;

    setShowGuarantorFields(newState.showGuarantorFields);
    setShowHomeLessFields(newState.showHomeLessFields);
    setShowPayerNameFields(newState.showPayerNameFields);
    setShowPatientFields(newState.showPatientFields);
    setShowBREFields(newState.showBREFields)
  }

  const handleSave = async () => {

    const newErrors = validateFields(); // Validate fields and get errors
    // Check if there are validation errors
    if (!newErrors) {
      const errorMessages = Object.values(validationErrors)
        .filter((error) => error !== '') // Filter out empty error messages
        .map((error) => <li key={error}>{error}</li>); // Format each error as a list item
  
      // Display validation errors using a message
      message.error(
        <div>
          <p>Validation Errors:</p>
        </div>,
        5 // Display for 5 seconds
      );
  
      return; // Exit the function early if there are validation errors
    }

    if (gridRecords && gridRecords.length > 0) {
      // Duplicate check
      // const isDuplicate = gridRecords.some(record =>
      //   record.clientName.trim().toLowerCase() === data.clientName.trim().toLowerCase() &&
      //   record.region.trim().toLowerCase() === data.region.trim().toLowerCase() &&
      //   //record?.senderCode === data.facilityCode.trim().toLowerCase() &&
      //   record.accountNumber.trim() === data.accountNumber.trim() &&
      //   //record.mrn.trim().toLowerCase() === data.mrn.trim().toLowerCase() &&
      //   //record.requestType.trim().toLowerCase() === data.requestType.trim().toLowerCase() &&
      //   //record.sendTo.trim().toLowerCase() === data.sendTo.trim().toLowerCase() &&
      //   //record.transactionStatus <= 5 &&
      //   // Exclude current record if updating
      //   (data.inventoryMasterId < 1 || record.inventoryMasterId !== data.inventoryMasterId)
      // );

      //if(isDuplicate){
        const userConfirmed = window.confirm('A record with this account number already exists and is currently In‑Progress. Would you like to continue and create another inventory entry?'); // Show confirmation box
        if(userConfirmed){
          saveDetails();
        }
        else{
          return;
        }
      // }
      // else{
      //   //saveDetails();
      // }
    }
    else{
        saveDetails();
      }
  };

  const saveDetails = async () => {

    //const tokenurl = process.env.REACT_APP_RRD_OPTIMIZATION_TOKEN_URL as string;
    const baseurl = process.env.REACT_APP_RRD_OPTIMIZATION_BASE_URL as string;

    //const getToken = await axios.get(tokenurl);

    //if (!getToken.data.success) { return; }
    const axiosMethod = data.inventoryMasterId > 0 ? axios.put : axios.post;
    const endpoints = data.inventoryMasterId > 0 ? '/Inventory/UpdateInventoryDetails' : '/Inventory/Add';

    const payload = {
      inventoryMasterId: data.inventoryMasterId,
      clientName: data.clientName,
      region: data.region,
      sourceSystem: "RAV",
      sourceInventoryId: "NA",
      transactionStatus: data.inventoryMasterId > 0 ? 2: 1,
      componentName: "RAVUI",
      remarks: data.inventoryMasterId > 0 ? "Inventory edited and renewed" : "Add new inventory from RAV Print UI",
      createdBy: userid,
      modifiedBy: userid,
      isActive: true,
      requestType: data.requestType,
      claimInformation: {
        accountNumber: data.accountNumber.trim(),
        mrn: data.mrn,
        claimNo: "",
        patientName: "",
        patientDOB: ""
      },
      senderInformation: {
        sendFrom: data.sendFrom,
        name: data.facilityName,
        address: data.facilityAddress,
        city: data.facilityCity,
        state: data.facilityState,
        zip: data.facilityZip,
        code: data.facilityCode,
        phoneNo: ''
      },
      receiverInformation: {
        displayName: data.displayName.trim(),
        sendTo: data.sendTo.trim(),
        name: data.sendTo === 'Override Address' ? data.lastName.trim() + ', ' + data.firstName.trim() : data.payerName.trim(),
        address: data.address.trim(),
        city: data.city.trim(),
        state: data.state.trim(),
        zip: data.zip.trim(),
        code: "",
        phoneNo: ""
      }
    }
    setuploading(true);
    try {
      const response = await axiosMethod(`${baseurl}${endpoints}`, JSON.stringify(payload), {
        headers: {
          'Content-Type': 'application/json'
        },
      });
      if (response.data.success) {
        if (data.inventoryMasterId < 1) {
          const inventoryResponse = await axios.get(`${baseurl}/Inventory/${response.data.result}`, {
            headers: {
              'Content-Type': 'application/json'
            },
          });

          if (inventoryResponse.data.success) {
            setdata((prevdata) => ({
              ...prevdata,
              inventoryMasterId: inventoryResponse.data.result?.inventoryMasterId || 0,
              transactionId: inventoryResponse.data.result?.transactionId || '',
              clientName: inventoryResponse.data.result?.clientName || '',
              lockboxAddress: inventoryResponse.data.result.senderInformation?.senderAddress || '',
              region: inventoryResponse.data.result?.region || '',
              accountNumber: inventoryResponse.data.result.claimInformation?.accountNumber || '',
              mrn: inventoryResponse.data.result.claimInformation?.mrn || '',
              senderName: inventoryResponse.data.result.senderInformation?.name || '',
              senderAddress: inventoryResponse.data.result.senderInformation?.address || '',
              senderCity: inventoryResponse.data.result.senderInformation?.City || '',
              senderState: inventoryResponse.data.result.senderInformation?.state || '',
              senderZip: inventoryResponse.data.result.senderInformation?.zip || '',
              facilityCode: inventoryResponse.data.result.senderInformation?.code || '',
              facilityPhoneNo: inventoryResponse.data.result.senderInformation?.phoneNo || '',
              requestType: inventoryResponse.data.result?.requestType || '',
            }))
          }
        }
        message.success('Data saved successfully!');
        //setIsDataSaved(true);
        if (refreshData) {
          refreshData();
        }
      }
    }
    catch (error: any) {
      message.error('Error saving data:- ' + error.response.data.message);
    }
    finally{
      setuploading(false);
    }
  }

  const validateFields = () => {    
    const newErrors = { 
      clientName: '', 
      region: '',
      accountNumber: '', 
      mrn:'',
      sendTo: '', 
      requestType: '',
      firstName:'',
      lastNane:'',
      payerName: '', 
      address: '', 
      city: '', 
      state: '', 
      zip: '' 
    }; // Initialize error object

    if (data.clientName.trim() == '') {
      newErrors.clientName = 'Client Name is required'; 
    }
    if (data.region.trim() == '') {
      newErrors.region = 'Region is required'; 
    }
    if (data.accountNumber.trim() == '') {
      newErrors.accountNumber = 'Account Number is required';
    }
    if (data.mrn.trim() == '') {
      newErrors.mrn = 'MRN is required'; 
    }
    if(data.sendTo.trim() == ''){
      newErrors.sendTo = 'Send To is required'; 
    }
    if (data.requestType.trim() == '') {
      newErrors.requestType = 'Request Type is required'; 
    }

    if (data.sendTo.trim() == 'Payer' || data.sendTo.trim() == 'Homeless' || data.sendTo.trim() == 'Override Address') {
      if (data.payerName.trim() == '' && data.sendTo.trim() == 'Payer') {
        newErrors.payerName = 'Payer Name is required';
      }
      if (!data.address.trim()) {
        newErrors.address = 'Address is required';
      }
      if (!/^[A-Z]{2}$/.test(data.state)) {
        newErrors.state = 'State name is invalid. Maxlength allowed is 2 alphabets in UPPERCASE';
      }
      if (!data.state.trim()) {
        newErrors.state = 'State is required';
      }
      if (!data.city.trim()) {
        newErrors.city = 'City is required';
      }
      if (!/^\d{5}(-\d{4})?$/.test(data.zip)) {
        newErrors.zip = 'Zip code is invalid. Please use ##### or #####-#### format.'
      }
      if (!data.zip.trim()) {
        newErrors.zip = 'Zip code is required';
      }
    }
    if (data.sendTo.trim() == 'Override Address') {
      if (!data.firstName.trim()) {
        newErrors.firstName = 'First Name is required';
      }
      if (!data.lastName.trim()) {
        newErrors.lastNane = 'Last name is required';
      }
    }
    setValidationErrors(newErrors); // Update errors state

    // Return true if there are no errors
    return Object.values(newErrors).every((error) => error === '');
  };

  // const userClientName = parsedUserDetails && parsedUserDetails[0]?.clientName !== ''
  //   ? parsedUserDetails[0]?.clientName
  //   : '';

  // const userClientNames: string[] = Array.from(new Set<string>(
  //   userClientName
  //     .split(',')
  //     .map((clientName: string) => clientName.trim())
  //     .filter(Boolean)
  // ));

  const userClientNames = ['Dignity'];

  const clientNameOptions = userClientNames.map((clientName) => ({
    label: clientName,
    value: clientName,
  }));

  return (
    <div>
      <Modal
        dataTestId="RRDModal-modalHeader"
        isOpen={isOpen} // Modal visibility controlled by isOpen prop
        onClickOut={() => setIsOpen(false)} // Close modal when clicking outside
        size="large"
        domID="RRD-modal"
        closeModalOnClickOut={true}
      >
        <ModalHeader
          title="Add Inventory"
          dataTestId="test-header"
          description="Fill in details below and click save to add the inventory."
          onClose={() => setIsOpen(false)} // Close modal when clicking the close button
        />
        <ModalBody>
          <Container>
            <div>
              <label htmlFor="clientname-id" style={{ fontWeight: 'bold' }} className="uicl-label">
                Client Name <span style={{ color: 'red' }}>*</span>
              </label>
              <div>
                <SelectDropdown
                  ariaLabel="ARIA label"
                  dataTestId="clientname-selectDropdownBasic"
                  domID="clientname-id"
                  placeholderText="Select..."
                  isClearable={false}
                  zIndex={99}
                  initialValue={{ label: data.clientName, value: data.clientName }}
                  onChange={(e) => handleChange(e, 'clientName')} // Pass the dropdown ID
                  options={clientNameOptions}
                  disabled={rrdInventoryItem?.inventoryMasterId > 0 ? true : false}
                />
                {validationErrors.clientName && (
                  <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.clientName}</span>
                )}
              </div>
              <label htmlFor="Facility Address" style={{ fontWeight: 'bold' }} className="uicl-label">
                Facility Address <span style={{ color: 'red' }}>*</span>
              </label>
              <div>
                <SelectDropdown menuWidth={800}
                  domID="Facility Address"
                  aria-label="Facility Address"
                  dataTestId="facilityaddress-selectDropdownBasic"
                  size="medium"
                  placeholderText="Billing Lockbox Address"
                  isClearable={false}
                  initialValue={{ label: (data.facilityName + ' - ' + data.facilityAddress + ' - ' + data.facilityCity + ' - ' + data.facilityState + ' - ' + data.facilityZip), value: data.facilityAddressId.toString() }}
                  onChange={(e) => handleChange(e, 'lockboxAddress')}
                  disabled={rrdInventoryItem?.inventoryMasterId > 0 ? true : false}
                  customFilter={(option, searchText) => {
                    const lowerCaseSearchText = searchText.toLowerCase();
                    return (
                      option?.label?.toLowerCase().includes(lowerCaseSearchText) || // Match label
                      option?.value?.toLowerCase().includes(lowerCaseSearchText)    // Match value
                    ) || false; // Ensure a boolean is always returned
                  }}
                  options={facilityAddressList.map((facility) => ({
                    label: `${facility.facilityCode} - ${facility.facilityName} - ${facility.lockboxAddress} - ${facility.lockboxCity} - ${facility.lockboxState} - ${facility.lockboxZip}`,
                    value: facility.facilityAddressId.toString(),
                  }))}
                />
              </div>
              <label htmlFor="region-id" style={{ fontWeight: 'bold' }} className="uicl-label">
                Region <span style={{ color: 'red' }}>*</span>
              </label>
              <div>
                <SelectDropdown
                  ariaLabel="ARIA label"
                  dataTestId="region-selectDropdownBasic"
                  domID="region-id"
                  placeholderText="Select..."
                  onChange={(e) => handleChange(e, 'region')}
                  isClearable={false}
                  zIndex={99}
                  initialValue={{ label: data.region, value: data.region }}
                  disabled={rrdInventoryItem?.inventoryMasterId > 0 ? true : false}
                  options={arrregioncodes.map(code => ({ label: code, value: code }))}
                />
                {validationErrors.region && (
                  <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.region}</span>
                )}
              </div>
              <label htmlFor="pan-number" style={{ fontWeight: 'bold' }} className="uicl-label">
                Patient Account Number <span style={{ color: 'red' }}>*</span>
              </label>
              <div>
                <Input
                  domID="pan-number"
                  aria-label="Patient Account Number"
                  size="medium"
                  placeholder="Patient Account Number"
                  initialValue={data.accountNumber}
                  onChange={(e) => handleChange(e.target, 'accountNumber')} // Pass the input value
                  disabled={rrdInventoryItem?.inventoryMasterId > 0 ? true : false}
                />
                {validationErrors.accountNumber && (
                  <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.accountNumber}</span>
                )}
              </div>
              <label htmlFor="MRN" style={{ fontWeight: 'bold' }} className="uicl-label">
                MRN <span style={{ color: 'red' }}>*</span>
              </label>
              <div>
                <Input
                  domID="MRN"
                  aria-label="MRN"
                  size="medium"
                  placeholder="MRN"
                  initialValue={data.mrn}
                  onChange={(e) => handleChange(e.target, 'mrn')}
                />
                {validationErrors.mrn && (
                  <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.mrn}</span>
                )}
              </div>
              <div>
                <label htmlFor="requesttype-id" style={{ fontWeight: 'bold' }} className="uicl-label">
                  Request Type <span style={{ color: 'red' }}>*</span>
                </label>
                <SelectDropdown
                  ariaLabel="ARIA label"
                  dataTestId="requesttype-selectDropdownBasic"
                  domID="requesttype-id"
                  placeholderText="Select..."
                  isClearable={false}
                  zIndex={99}
                  initialValue={{ label: data.requestType, value: data.requestType }}
                  onChange={(e) => handleRequestTypeChange(e, 'requestType')}
                  options={[
                    { label: 'Insurance/Payer', value: 'Payer' },
                    { label: 'Patient', value: 'Patient' }
                  ]} />
                {validationErrors.requestType && (
                  <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.requestType}</span>
                )}
              </div>
              <div>
                <label htmlFor="sendto-id" style={{ fontWeight: 'bold' }} className="uicl-label">
                  Send To <span style={{ color: 'red' }}>*</span>
                </label>
                <SelectDropdown
                  ariaLabel="ARIA label"
                  dataTestId="sendto-selectDropdownBasic"
                  domID="sendto-id"
                  placeholderText="Select..."
                  isClearable={false}
                  zIndex={99}
                  initialValue={{ label: data.sendTo, value: data.sendTo }} // Dynamically update initialValue
                  options={
                    data.requestType === 'Patient'
                      ? [{ label: 'Patient', value: 'Patient' },
                        { label: 'Override Address', value: 'Override Address' }
                      ]
                      : [
                          { label: 'Payer', value: 'Payer' },
                          { label: 'Patient', value: 'Patient' },
                          { label: 'Override Address', value: 'Override Address' },
                        ]
                  }
                  onChange={(e) => handleChange(e, 'sendTo')} // Update state on change
                />
                {validationErrors.sendTo && (
                  <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.sendTo}</span>
                )}
              </div>
              {(showPayerNameFields || showHomeLessFields || showBREFields) && (<div>
                {showPayerNameFields && (<div>
                  <div ref={payerNameDivRef} style={{ position: 'relative', marginTop: '10px' }}>
                    <label htmlFor="payer-name" style={{ fontWeight: 'bold' }} className="uicl-label">
                      Search or Select Payer Name <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Input
                      domID="payer-name"
                      aria-label="Search Payer Name"
                      size="medium"
                      placeholder="Type to search..."
                      value={data.payerName}
                      onChange={(e) => {
                        //setSearchText(e.target.value); // Update search text
                        setdata((prevdata) => ({ ...prevdata, payerName: e.target.value }))
                        setShowDropdown(true); // Show dropdown when typing
                        //handleChange(e.target, 'payerName')
                      }}
                      onClick={() => setShowDropdown(true)} // Show dropdown when clicked
                      maxLength={50}
                    />
                    {validationErrors.payerName && (
                      <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.payerName}</span>
                    )}
                    {showDropdown && showPayerNameFields && (
                      <div
                        ref={payerNameDropdownRef} // Attach the ref to the dropdown
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          backgroundColor: 'white',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          zIndex: 11050, // Ensure dropdown appears above the modal
                          maxHeight: '400px',
                          overflowY: 'auto',
                        }}
                      >
                        {filteredOptions.length > 0 ? (
                          filteredOptions.map((option) => (
                            <div
                              key={option.value}
                              style={{
                                padding: '10px',
                                cursor: 'pointer',
                                borderBottom: '1px solid #eee',
                              }}
                              onClick={() => handleOptionClick(option)}
                            >
                              {option.label}
                            </div>
                          ))
                        ) : (
                          <div
                            style={{
                              padding: '10px',
                              textAlign: 'center',
                              color: '#999',
                            }}
                          >
                            No options found
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div>
                      <label htmlFor="displayName" style={{ fontWeight: 'bold' }} className="uicl-label">
                        Display Name
                      </label>
                      <Input
                        domID="displayName"
                        aria-label="displayName"
                        size="medium"
                        placeholder="Display Name"
                        initialValue={data.displayName}
                        onChange={(e) => handleChange(e.target, 'displayName')}
                        maxLength={50}
                      />
                    </div>
                </div>)}

                {showBREFields && (
                  <div>
                    <Row>
                      <Col sm={6}>
                        <label htmlFor="state" style={{ fontWeight: 'bold' }} className="uicl-label">
                          First Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Input
                          domID="firstName"
                          aria-label="firstName"
                          size="medium"
                          placeholder="First Name"
                          style={{ width: '100%', float: 'left' }}
                          value={data.payerName.split(',')[1]}
                          onChange={(e) => handleChange(e.target, 'firstName')}
                        />
                        {validationErrors.firstName && (
                          <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.firstName}</span>
                        )}
                      </Col>
                      <Col sm={6}>
                        <label htmlFor="zip" style={{ fontWeight: 'bold' }} className="uicl-label">
                          Last Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Input
                          domID="lastName"
                          dataTestId="lastName-input-inline-validation"
                          aria-label="lastName"
                          size="medium"
                          placeholder="Last Name"
                          style={{ float: 'left' }}
                          initialValue={data.payerName.split(',')[0]}
                          onChange={(e) => handleChange(e.target, 'lastName')}
                        />
                        {validationErrors.lastNane && (
                          <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.lastNane}</span>
                        )}
                      </Col>
                    </Row>
                  </div>
                )}

                <div style={{ position: 'relative' }}>
                  <Row>
                    <Col sm={6}>
                      <label htmlFor="address" style={{ fontWeight: 'bold' }} className="uicl-label">
                        Address <span style={{ color: 'red' }}>*</span>
                      </label>
                      <Input
                        domID="address"
                        aria-label="address"
                        size="medium"
                        placeholder="Address"
                        style={{ width: '100%', float: 'left' }}
                        value={data.address} // Bind to state
                        maxLength={50}
                        onChange={(e) => {
                          // Allow only letters, numbers, spaces, and basic punctuation (customize as needed)
                          let inputValue = e.target.value;
                          if (inputValue.endsWith(',')) {
                            inputValue = inputValue.slice(0, -1);
                          }
                          setdata({ ...data, address: inputValue });
                          setPayerAddressSearchText(inputValue); // Update search text
                          setPayerAddressShowDropdown(true); // Show dropdown when typing
                        }}
                        onClick={data.sendTo === 'Payer' ? () => setPayerAddressShowDropdown(true) : () => setPayerAddressShowDropdown(false)} // Show dropdown when clicked
                      />
                      {payerAddressShowDropdown && payerAddressFilteredOptions.length > 0 && (
                        <div
                          ref={payerAddressDropdownRef}
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            backgroundColor: 'white',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            zIndex: 11050, // Ensure dropdown appears above the modal
                            maxHeight: '400px',
                            overflowY: 'auto',
                          }}
                        >
                          {payerAddressFilteredOptions.map((option) => (
                            <div
                              key={option.value}
                              style={{
                                padding: '10px',
                                cursor: 'pointer',
                                borderBottom: '1px solid #eee',
                              }}
                              onClick={() => handlePayerAddressOptionClick(option)}
                            >
                              {option.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </Col>
                    <Col sm={6}>
                      <label htmlFor="city" style={{ fontWeight: 'bold' }} className="uicl-label">
                        City <span style={{ color: 'red' }}>*</span>
                      </label>
                      <Input
                        domID="city"
                        aria-label="city"
                        size="medium"
                        placeholder="City"
                        style={{ float: 'left' }}
                        initialValue={data.city}
                        onChange={(e) => handleChange(e.target, 'city')}
                        maxLength={50}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <label htmlFor="state" style={{ fontWeight: 'bold' }} className="uicl-label">
                        State <span style={{ color: 'red' }}>*</span>
                      </label>
                      <Input
                        domID="state"
                        aria-label="state"
                        size="medium"
                        placeholder="State"
                        style={{ width: '100%', float: 'left' }}
                        initialValue={data.state}
                        onChange={(e) => handleChange(e.target, 'state')}
                        regex='^[A-Z]{2}$'
                        hasError={!/^[A-Z]{2}$/.test(data.state)}
                      />
                      {validationErrors.state && (
                      <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.state}</span>
                    )}
                    </Col>
                    <Col sm={6}>
                      <label htmlFor="zip" style={{ fontWeight: 'bold' }} className="uicl-label">
                        Zip <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                      </label>
                      <Input
                        domID="zip"
                        dataTestId="test-input-inline-validation"
                        aria-label="zip"
                        size="medium"
                        placeholder="Zip"
                        style={{ float: 'left' }}
                        value={data.zip}
                        onChange={(e) => handleChange(e.target, 'zip')}
                        regex="^\d{5}(-\d{4})?$"
                        hasError={!/^\d{5}(-\d{4})?$/.test(data.zip)}
                      />
                       {validationErrors.zip && (
                      <span style={{ color: 'red', fontSize: '12px' }}>{validationErrors.zip}</span>
                    )}
                    </Col>
                  </Row>
                </div>
              </div>)}
            </div>
          </Container>
        </ModalBody>
        <ModalFooter>
          {(data?.inventoryMasterId > 0) &&
            <Button
              buttonType="emphasized"
              name="Upload File"
              onClick={() => {
                setIsOpen(false); // Close the Add Inventory modal
                setUploadDocumentModalOpen(true); // Open the Upload File modal
              }}
            />}
          {/* <RRDDocumentUpload isOpen={isUploadDocumentOpen} setIsOpen={setIsUploadDocumentOpen} /> */}
          <ButtonGroup>
            <Button buttonType="diminished" name="Cancel" onClick={handleClose} />
            <Button buttonType="emphasized" name="Save" disabled = {uploading}  onClick={handleSave} />
          </ButtonGroup>
        </ModalFooter>
      </Modal>
      <RRDDocumentUpload
        isOpen={uploadDocumentModalOpen}
        setIsOpen={setUploadDocumentModalOpen}
        rrdInventoryItem={data}
        refreshData={fetchForms}
      />
    </div>
  );
}

export default RRDInventoryModal;